export const Reviews = [
    {
        id:1,
        star: '',
        name: 'Punit H. Ohio',
        write: 'We loved the quality of the paint! There’s hardly any smell which makes me feel so much better about being in a freshly painted home! I love the convenience of buying paint online, and the paint color was exactly what we hoped it would be based on the website! Will be using again!', 
    },
    {
        id:2,
        star: '',
        name: 'Jenny P. Verma',
        write: 'Of course, Sherwin-Williams would choose Urbane Bronze — a nature-inspired brown shade — as its 2021 Color of the Year. The rich hue is perfect for giving just about any space a cocoon-like feel.',
    },
    {
        id:1,
        star: '',
        name: 'Ronny S. Singania',
        write: 'If your interior is in need of some cheer, Farrow & Balls Babouche is the perfect pick. Interior designer Ariel Okin especially likes it for kids rooms. "Its a zingy, happy yellow that gets its name from the distinctive color of the leather slippers worn by men in Morocco, Okin says. I love using it as an accent color on millwork (think: trim and doors) for a fun pop of unexpected color in a playroom or childrens bedroom.',
    },
    {
        id:1,
        star: '',
        name: 'Pushpesh S. Sharma',
        write: 'Taking a cue from natures everlasting beauty, Valspar rounded up 12 gorgeous hues that bring the serenity of the outdoors to any room. Described by paint experts as a mature pink that is confidently cheerful like a spring sunset, Bombay Pink is best dressed with gold accents.',
    },
    {
        id:1,
        star: '',
        name: 'Jaan B. Ganeshan',
        write: 'Much bolder than the other paint colors on this list, Sherwin-Williams 2020 Color of the Year is a rich, statement-worthy navy. While classic and cool, this deep hue combines the power of nature with a timeless confidence straight from Art Deco designs.',
    },
]

export const Links = [
   {
       id: 1,
       url: 'Home',
   },
   {
       id: 2,
       url: 'Services',
   },
   {
       id: 3,
       url: 'Products',
   },
   {
       id: 4,
       url: 'About',
   },
   {
       id: 5,
       url: 'Contacts',
   },
   {
       id: 6,
       url: 'Paints',
   },
];